// extracted by mini-css-extract-plugin
module.exports = {"detail_con":"index_detail_con__42mHD","quote_right_fold":"index_quote_right_fold__12MT-","back_mobile":"index_back_mobile__1StPe","detail_con_1":"index_detail_con_1__29z_i"};